/*
 * Landing page B2B — client side validation for the lead forms.
 *
 * The forms are Shopify `customer` forms, so a submit is a full page POST.
 * Validating before the POST is what keeps the user's typing on screen when
 * something is missing: we block the submit and point at the offending field
 * instead of letting the page reload with the values gone.
 */
(function () {
  // Both the hero and the closing CTA request this file, so it runs twice.
  if (window.lpB2bLoaded) return;
  window.lpB2bLoaded = true;

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function fieldOf(input) {
    return input.closest('[data-lp-field]');
  }

  function setError(input, message) {
    var field = fieldOf(input);
    if (!field) return;

    var box = field.querySelector('[data-lp-field-error]');
    field.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');

    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
  }

  function clearError(input) {
    var field = fieldOf(input);
    if (!field) return;

    var box = field.querySelector('[data-lp-field-error]');
    field.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');

    if (box) {
      box.textContent = '';
      box.hidden = true;
    }
  }

  function validate(input) {
    var value = (input.value || '').trim();

    if (input.hasAttribute('required') && value === '') {
      setError(input, input.getAttribute('data-lp-error-required') || '');
      return false;
    }

    if (value !== '' && input.type === 'email' && !EMAIL_PATTERN.test(value)) {
      setError(input, input.getAttribute('data-lp-error-invalid') || '');
      return false;
    }

    clearError(input);
    return true;
  }

  function initForm(form) {
    if (form.dataset.lpReady === 'true') return;
    form.dataset.lpReady = 'true';

    // Only now that scripted messages are available do we suppress the native
    // bubbles — without JS the browser's own `required` handling still guards
    // the submit.
    form.setAttribute('novalidate', 'novalidate');

    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-lp-field] .lp-field__input'));

    inputs.forEach(function (input) {
      input.addEventListener('blur', function () {
        validate(input);
      });

      input.addEventListener('input', function () {
        var field = fieldOf(input);
        if (field && field.classList.contains('is-invalid')) validate(input);
      });
    });

    form.addEventListener('submit', function (event) {
      var firstInvalid = null;

      inputs.forEach(function (input) {
        if (!validate(input) && !firstInvalid) firstInvalid = input;
      });

      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
      }
    });
  }

  /*
   * Shopify bounces back to the page with `form_type=customer` in the query
   * string when the address is already registered. That case produces neither
   * `posted_successfully?` nor `form.errors`, so it has to be surfaced here.
   */
  function showReturnNotice() {
    if (window.location.search.indexOf('form_type=customer') === -1) return;

    var box = null;

    if (window.location.hash.length > 1) {
      try {
        var anchored = document.querySelector(window.location.hash);
        if (anchored) box = anchored.querySelector('[data-lp-notice]');
      } catch (error) {
        box = null;
      }
    }

    if (!box) box = document.querySelector('[data-lp-notice]');
    if (!box) return;

    // A real success or error message was already rendered for this form.
    var formbox = box.closest('[data-lp-formbox]');
    if (formbox && formbox.querySelector('.lp-alert--success, .lp-alert--error')) return;

    var text = box.querySelector('[data-lp-notice-text]');
    if (text) text.textContent = box.getAttribute('data-lp-notice-already') || '';

    box.hidden = false;
  }

  function init() {
    // `{% form %}` renders the <form> tag itself, so the hook lives on the
    // wrapper the snippet controls.
    document.querySelectorAll('[data-lp-formbox] form').forEach(function (form) {
      initForm(form);
    });
    showReturnNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when a section is re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
